import { ActionTypes } from '../constants';
import initialState from './initialState';

export default (state = initialState.blogs, { type, payload = {} }) => {
  switch (type) {

      case ActionTypes.GET_BLOGS_LIST_REQUEST:
      return {
        ...state,
        blogsList: {
          ...state.blogsList,
          loading: true,
          error: null
        },
        loading: true,
        error: null
      };

    case ActionTypes.GET_BLOGS_LIST_REQUEST_SUCCESS:
      return {
        ...state,
        blogsList: {
          data: payload.content || payload,
          loading: false,
          error: null,
          total: payload.totalElements || 0
        },
        loading: false,
        error: null
      };

    case ActionTypes.GET_BLOGS_LIST_REQUEST_FAILURE:
      return {
        ...state,
        blogsList: {
          ...state.blogsList,
          loading: false,
          error: payload || 'Failed to fetch blogs'
        },
        loading: false,
        error: payload || 'Failed to fetch blogs'
      };

    case ActionTypes.GET_BLOG_BY_ID_REQUEST_STARTED:
      return {
        ...state,
        loading: true,
        error: null
      };

    case ActionTypes.GET_BLOG_BY_ID_REQUEST_SUCCESS:
      return {
        ...state,
        currentBlog: payload,
        loading: false,
        error: null
      };

    case ActionTypes.GET_BLOG_BY_ID_REQUEST_FAILURE:
      return {
        ...state,
        loading: false,
        error: payload || 'Failed to fetch blog'
      };

    case ActionTypes.GET_BLOG_BY_SLUG_REQUEST_SUCCESS:
      return {
        ...state,
        currentBlog: payload,
        loading: false,
        error: null
      };

    case ActionTypes.GET_BLOG_BY_SLUG_REQUEST_FAILURE:
      return {
        ...state,
        loading: false,
        error: payload || 'Failed to fetch blog'
      };

    case ActionTypes.CREATE_BLOG_REQUEST_SUCCESS:
      return {
        ...state,
        blogsList: {
          ...state.blogsList,
          data: [payload, ...(state.blogsList.data || [])],
          total: (state.blogsList.total || 0) + 1,
          loading: false,
          error: null,
        },
        currentBlog: payload,
        loading: false,
        error: null
      };

    case ActionTypes.CREATE_BLOG_REQUEST_FAILURE:
      return {
        ...state,
        loading: false,
        error: payload || 'Failed to create blog'
      };

    case ActionTypes.UPDATE_BLOG_REQUEST_SUCCESS:
      return {
        ...state,
        blogsList: {
          ...state.blogsList,
          data: (state.blogsList.data || []).map(blog =>
            blog.id === payload.id ? payload : blog
          ),
        },
        currentBlog: payload,
        loading: false,
        error: null
      };

    case ActionTypes.UPDATE_BLOG_REQUEST_FAILURE:
      return {
        ...state,
        loading: false,
        error: payload || 'Failed to update blog'
      };

    case ActionTypes.DELETE_BLOG_REQUEST_SUCCESS:
      const blogIdToDelete = payload.id || payload;

      return {
        ...state,
        blogsList: {
          ...state.blogsList,
          data: (state.blogsList.data || []).filter(blog => blog.id !== blogIdToDelete),
          total: Math.max((state.blogsList.total || 1) - 1, 0),
        },
        currentBlog: {},
        loading: false,
        error: null
      };

    case ActionTypes.DELETE_BLOG_REQUEST_FAILURE:
      return {
        ...state,
        loading: false,
        error: payload || 'Failed to delete blog'
      };

    case ActionTypes.SEARCH_BLOGS_REQUEST_SUCCESS:
      return {
        ...state,
        blogsList: {
          ...state.blogsList,
          data: payload.content || payload || [],
          total: payload.totalElements || (Array.isArray(payload) ? payload.length : 0),
          loading: false,
          error: null,
        },
        loading: false,
        error: null
      };

    case ActionTypes.SEARCH_BLOGS_REQUEST_FAILURE:
      return {
        ...state,
        loading: false,
        error: payload || 'Failed to search blogs'
      };

    case ActionTypes.CLEAR_CURRENT_BLOG:
      return {
        ...state,
        currentBlog: {}
      };

    case ActionTypes.CLEAR_BLOGS_LIST:
      return {
        ...state,
        blogsList: { data: [], loading: false, error: null, total: 0 }
      };

    default:
      return state;
  }
};
